define((require) => {
    "use strict";

    const ErrorHandler = require("shared/services/error/ErrorHandler");
    const SyncManager = require("shared/services/sync/SyncManager");
    const RestApi = require("shared/services/RestApi");

    const PushResourceType = {
        PUSH_GROUPS: "PUSH_GROUPS",
        PUSH_EXPERIENCES: "PUSH_EXPERIENCES",
        PUSH_SETTINGS: "PUSH_SETTINGS"
    };

    function _syncCombinedResource(resourceId, companyId, pushType) {
        const url = RestApi.pathToCollectionOnResource(
            RestApi.Collections.COMPANIES,
            companyId,
            RestApi.Collections.COMBINED,
            true
        );

        return SyncManager.sync({
            method: "put",
            promise: true,
            fn: {
                url,
                type: "PUT",
                contentType: "application/json",
                data: JSON.stringify({
                    "resourceId": resourceId,
                    "combinedPushType": pushType
                })
            },
            errorHandler: (error) => {
                ErrorHandler.inject(error, {
                    method:  "fetch",
                    name: RestApi.Collections.COMBINED
                });
                return "alert";
            }
        }).promise();
    }

    /**
     * Contains combined experiences and groups sync functions.
     *
     * @class ResourceCombined
     */
    const ResourceCombined = {
        /**
         *
         * @param {{String}} groupId    The groupId to sync combined resource
         * @param {{String}} companyId  The companyId to sync combined resource
         */
        syncGroup(groupId, companyId) {
            return _syncCombinedResource(groupId, companyId, PushResourceType.PUSH_GROUPS);
        },

        /**
         *
         * @param {{String}} experienceId    The groupId to sync combined resource
         * @param {{String}} companyId  The companyId to sync combined resource
         */
        syncExperience(experienceId, companyId) {
            return _syncCombinedResource(experienceId, companyId, PushResourceType.PUSH_EXPERIENCES);
        }
    };

    return ResourceCombined;
});



// WEBPACK FOOTER //
// ./src/shared/util/ResourceCombined.js